import {useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabCentralModel} from '../../../../../../models'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../../hoteleria/hooks/useCentralServices'
import {ConfigDocumentColumnModel} from '../../../../model/configDocument.model'
import {getDocsConfig} from '../../../../services/configDocument.service'

const TableConfigDocument = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {searchValues, clearSearchValues} = useKhipu()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useCentral()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])

  const {getCompanies, getClients, getSites} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  useEffect(() => {
    getCompaniesFn()
    getClientsFn()
    getSitesFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getConfigDocumentList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getDocsConfig(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleShowDetail = (item: ConfigDocumentColumnModel) => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-config-document',
      },
      idToDelete: '',
      idToEdit: item.Id as any,
      objectInfo: item,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getConfigDocumentList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }

      // setData([])
      setClearTable(false)
    }
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getConfigDocumentList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(() => {
    getConfigDocumentList()
    clearSelected()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      getConfigDocumentList()
      clearSelected()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [currentTabItem.loadingTable])

  const columns: Column<ConfigDocumentColumnModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={() => handleGetId(props.row.original.Id)}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='CompaniaId'
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Valor Base' name={'ValorBase'} searcheable />
        ),
        accessor: 'ValorBase',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tipo Dato' name={'TipoDato'} searcheable />
        ),
        accessor: 'TipoDato_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Direccion' name={'Direccion'} searcheable />
        ),
        accessor: 'Direccion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Expresion' name={'Expresion'} searcheable />
        ),
        accessor: 'Expresion',
        Cell: ({...props}) => {
          const decodeContent = () => {
            try {
              const decodedContent = decodeURIComponent(escape(atob(props.row.original.Expresion!)))
              return decodedContent
            } catch (error) {
              const decodedContent = decodeURIComponent(
                props.row.original.Expresion!.replace(/\+/g, ' '),
              )
              return decodedContent
            }
          }
          return <div>{decodeContent()}</div>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [selectedOn, compani, client, site],
  )

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns as any} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableConfigDocumentWrapper = () => {
  return (
    <KTableProvider>
      <TableConfigDocument />
    </KTableProvider>
  )
}

export {TableConfigDocumentWrapper}
